module.exports = __webpack_public_path__ + "static/editselector-f49a80a6372524248fbb4739aa68e2e9.mp4";